import { createContext } from 'react'
import { decorate, action } from 'mobx'

import { CartStore } from './CartStore'
import { DeliveryUserInfoStore } from './DeliveryUserInfoStore'
import { CurrencyStore } from './CurrencyStore'
import { BenzobotStore } from './BenzobotStore'
import { StructureWorkStore } from './StructureWorkStore'

export class RootStore {
  constructor() {
    this.cartStore = new CartStore(this)
    this.deliveryUserInfoStore = new DeliveryUserInfoStore(this)
    this.currencyStore = new CurrencyStore(this)
    this.benzobotStore = new BenzobotStore(this)
    this.structueWorkStore = new StructureWorkStore(this)
  }

  clear() {
  }
}

decorate(RootStore, {
  clear: action,
})

export const rootStore = new RootStore()

export const RootStoreContext = createContext(rootStore)
